export default "__VITE_ASSET__TgnazXFL__"